export default __webpack_public_path__ + "static/media/logo-ps-202x2.87ac43f7.svg";